import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import WatermarkPreviewList from '../../../../../form-fields/super-cut/watermark-preview-list'

const WatermarkPreview = styled(WatermarkPreviewList)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoWatermarkFilePreview = ({ field }: Props) => {
    return (
        <WatermarkPreview
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoWatermarkFilePreview
